import { useMemo, useState } from 'react';
import useDebouncedValue from './useDebouncedValue';

export default function useFilteredItemsByToken(items: DataItem[], debounce = 200) {
  const [searchToken, setSearchToken] = useState('');

  const filterToken = searchToken.toLowerCase().trim();

  const debouncedToken = useDebouncedValue(filterToken, debounce);

  const filteredItems = useMemo(() => {
    if (debouncedToken) {
      return items.filter((item) => item.label.toLowerCase().includes(debouncedToken));
    }
    return items;
  }, [debouncedToken, items]);

  return [filteredItems, searchToken, setSearchToken] as const;
}
